import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["children", "useEmptyPlaceholder", "animated", "hover"],
  _excluded2 = ["src", "srcSet"],
  _excluded3 = ["className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './LazyPicture.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
import { useInView } from 'react-intersection-observer';
import { qsToObject } from '../../../utils/querystring';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var LazyPicture = function LazyPicture(_ref) {
  var children = _ref.children,
    _ref$useEmptyPlacehol = _ref.useEmptyPlaceholder,
    useEmptyPlaceholder = _ref$useEmptyPlacehol === void 0 ? false : _ref$useEmptyPlacehol,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? true : _ref$animated,
    _ref$hover = _ref.hover,
    hover = _ref$hover === void 0 ? false : _ref$hover,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useInView = useInView({
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useMemo = React.useMemo(function () {
      if (typeof window === 'undefined') return {
        padding: 0,
        cw: '',
        ch: ''
      };
      return children.reduceRight(function (acc, child) {
        var _child$props2 = child.props,
          src = _child$props2.src,
          srcSet = _child$props2.srcSet,
          media = _child$props2.media;
        var _ref2 = media ? qsToObject(srcSet) : qsToObject(src),
          cw = _ref2.cw,
          ch = _ref2.ch;
        if (!cw || !ch) return acc;
        var mq = media && window.matchMedia(media);
        if (media && (!mq || !mq.matches)) return acc;
        var padding = parseInt(ch) * 100 / parseInt(cw);
        return {
          padding: padding,
          cw: cw,
          ch: ch
        };
      }, {
        padding: 0,
        cw: '',
        ch: ''
      });
    }, [children]),
    padding = _React$useMemo.padding,
    cw = _React$useMemo.cw,
    ch = _React$useMemo.ch;
  var isVerticalImage = padding > 100;
  var processedChildren = React.useMemo(function () {
    if (inView || !animated || pageEditing) return children;
    return children.map(function (child, index) {
      var _child$props = child.props,
        src = _child$props.src,
        srcSet = _child$props.srcSet,
        props = _objectWithoutProperties(_child$props, _excluded2);
      var key = "".concat(child.type.toString(), "-").concat(index);
      return child.props.src ? /*#__PURE__*/React.createElement(child.type, _extends({}, props, {
        "data-src": src,
        key: key
      })) : /*#__PURE__*/React.createElement(child.type, _extends({}, props, {
        "data-srcset": srcSet,
        key: key
      }));
    });
  }, [inView, children, animated]);

  // ignoring classname prop from upstream
  var className = otherProps.className,
    pictureProps = _objectWithoutProperties(otherProps, _excluded3);
  var pictureClassName = "".concat(picture, " ").concat(animated ? animatedPicture : null, " ").concat(className ? className : null);
  var Picture = /*#__PURE__*/React.createElement("picture", _extends({
    ref: ref,
    className: "".concat(pictureClassName, " ").concat(hover ? 'empty-placeholder--hover' : '')
  }, pictureProps), processedChildren);
  return useEmptyPlaceholder && padding ? /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "empty-placeholder",
    padding: padding,
    cw: cw,
    ch: ch,
    isVerticalImage: isVerticalImage
  }, Picture) : Picture;
};
var StyledWrapper = /*#__PURE__*/styled("div")({
  name: "StyledWrapper",
  class: "s17v4aoz",
  vars: {
    "s17v4aoz-0": [function (props) {
      return props.isVerticalImage && props.cw ? '100%' : 'unset';
    }],
    "s17v4aoz-1": [function (props) {
      return props.isVerticalImage && props.ch ? '100%' : 'unset';
    }],
    "s17v4aoz-2": [function (props) {
      return props.isVerticalImage && props.cw ? "".concat(props.cw, "px") : 'unset';
    }],
    "s17v4aoz-3": [function (props) {
      return props.isVerticalImage && props.ch ? "".concat(props.ch, "px") : 'unset';
    }],
    "s17v4aoz-4": [function (props) {
      return "".concat(props.padding, "%");
    }]
  }
});
var picture = "p1h540cx";
var animatedPicture = "a1rjuo98";
export default LazyPicture;